import { useContext, useEffect, useRef, useState } from "react";
import './index.less'
import { SideHeader, ContextMenu, MenuList, MenuItem, TnModal, FloatModal, IconButton, Dropdown, LeftSideList } from "bimui";
import { Image, Table, message } from "antd";
import classNames from 'classnames';
import { useNavigate, useParams } from "react-router-dom";
import { createSection, deleteProjectSection, deleteProjectSectionBySectionIds, findProjectSectionList, findProjectSectionsGroup } from "@/declare/api/project/project-section";
import { ReactComponent as SelectedSvg } from './icons/selected.svg';
import { ReactComponent as SuspensionSvg } from './icons/suspension.svg';
import { ReactComponent as AddSvg } from './icons/add.svg';
import { ReactComponent as Add32Svg } from 'bimui/dist/c1/icons/new-default_32.svg';

import { ReactComponent as NewSvg } from './icons/new.svg';
import { SectionType, Section, ProjectSection } from "@/declare/interface/project/section";
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { BaseUtils } from 'tnbase';
import SectionModal from "./section-model";
import localStore from "@/store/local-store";
import { SIDEBAR_TYPE } from "@/declare/enums/menu-type";

/**
 * 截面侧边栏面板组件，展示项目中的截面列表，并提供添加、删除、复制等操作。
 * 支持右键菜单功能、弹窗展示截面详情及自定义截面。
 * @param {Object} props - 组件属性
 * @returns {JSX.Element} 渲染的组件
 */
export default function SectionPanelComponent() {
    const routeParams = useParams();
    const navigate = useNavigate();

    /**
     * 从 URL 中提取项目 UUID 参数
     */
    const { projectUuid } = useParams();
    /**
     * 控制右键菜单是否显示
     */
    const [cmOpen, setCmOpen] = useState<boolean>(false);
    /**
     * 右键菜单的纵坐标位置
     */
    const [cmTop, setCmTop] = useState<number>();
    /**
     * 右键菜单的横坐标位置
     */
    const [cmLeft, setCmLeft] = useState<number>();
    /**
     * 当前项目的完整截面列表数据
     */
    const [projectSection, setProjectSection] = useState<Section[]>([]);
    /**
     * 显示的项目截面列表数据(被筛选后的数据)
     */
    const [displaySection, setDisplaySection] = useState<Section[]>([]);
    /**
     * 当前右键选中的项目库截面
     */
    // const [activeItem, setActiveItem] = useState<Section>();
    /**
     * 当前双击选择的截面详情选项
     */
    const [detailItem, setDetailItem] = useState<Section>();

    /**
     * 当前单击选中的截面选项数组（参考window可以储存多选选中的截面信息）
     */
    const [selecItems, setSelecItems] = useState<Section[]>();

    const [hoveredItem, setHoveredItem] = useState<Section | null>(null); // 用于存储当前悬浮的行（为了显示不一样的样式）
    /**
     * 记录最后一次单击的行索引
     */
    const [lastSelectedIndex, setLastSelectedIndex] = useState<number | null>(null);
    /**
     * ctrl键是否被按下
     */
    const [ctrlPressed, setCtrlPressed] = useState<boolean>(false);
    /**
     * shift 键是否被按下
     */
    const [shiftPressed, setShiftPressed] = useState<boolean>(false);
    /**
     *  是否双击
     */
    const isDbClickRef = useRef<boolean>(false);

    /**
     * 截面类下拉框的选项列表
     */
    const [sectionCategoryList, setSectionCategoryList] = useState<{ label: string; value: string }[]>([]);

    /**
     * 截面类下拉框的选中值
     */
    const [sectionCategory, setSectionCategory] = useState(null);
    /**
     * 截面标准下拉框的选项列表
     */
    const [standardList, setStandardList] = useState<{ label: string; value: string }[]>([]);
    /**
     * 截面标准下拉框的选中值
     */
    const [standard, setStandard] = useState(null);

    const [sectionTypeList, setSectionTypeList] = useState<SectionType[]>([]); // 截面分类图标列表
    const [displayTypeList, setDisplayTypeList] = useState<SectionType[]>([]); // 筛选后显示的截面分类图标列表
    const [selectedSectionTypeId, setSelectedSectionTypeId] = useState(null); // 选中的截面分类

    /**
     * 控制添加系统库截面的弹窗
     */
    const [showAddModal, setShowAddModal] = useState<boolean>(false);

    /**
     * 接收事件，当当点击通用工具栏的删除或编辑时，更新删除或编辑标识符，并执行正常的删除与编辑操作
     */
    const [deleteFlag, setDeleteFlag] = useState<string>("");
    const [editFlag, setEditFlag] = useState<string>("");

    useEffect(() => {
        let status = localStore.getSidebarStatus(SIDEBAR_TYPE.SECTION);
        setSelecItems(status['selecItems'] || []);
        setSelectedSectionTypeId(status['activeItem']);
    }, [])

    useEffect(() => {
        if (selectedSectionTypeId == null || selecItems == null) return;
        updateStatus(selectedSectionTypeId, selecItems);
    }, [selecItems, selectedSectionTypeId])

    const updateStatus = (activeItem, selecItems: any) => {
        // 在这里向外传递状态
        let status = {
            activeItem: activeItem,
            selecItems: selecItems,
        };
        localStore.setSidebarStatus(SIDEBAR_TYPE.SECTION, status);
    }

    useEffect(() => {
        const handleDelete = () => setDeleteFlag(BaseUtils.genUUID());
        const handleEdit = () => setEditFlag(BaseUtils.genUUID());

        emitter.on(Emit_Event_Common_Tool.DELETE, handleDelete);
        emitter.on(Emit_Event_Common_Tool.EDIT, handleEdit);

        return () => {
            emitter.off(Emit_Event_Common_Tool.DELETE, handleDelete);
            emitter.off(Emit_Event_Common_Tool.EDIT, handleEdit);
        };
    }, []);

    useEffect(() => {
        if (!deleteFlag || selecItems.length === 0) return;
        onDelete();
    }, [deleteFlag]);

    useEffect(() => {
        if (!editFlag || selecItems.length === 0) return;
        // setShowModal(true);
        setCmOpen(false);
    }, [editFlag]);

    /**
     * 监听路由变化，判断是否正在查看截面页签
     */
    useEffect(() => {
        if (!routeParams) return;
        // 获取 sectionId
        let url = routeParams['*'];
        let sectionId = url.split("section-details/")[1];
        if (!sectionId) return;

        // 根据 sectionId 查找对应的 Section
        const matchedSection = projectSection.find(section => section.id === sectionId);

        // 如果找到，设置到 detailItem
        if (matchedSection) {
            setDetailItem(matchedSection);
        }
    }, [routeParams, projectSection]);

    /**
     * 处理鼠标点击事件的监听
     * 监听ctrl、shift键的按下和抬起事件
     */
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Control") setCtrlPressed(true);
            if (e.key === "Shift") setShiftPressed(true);
        };

        const handleKeyUp = (e: KeyboardEvent) => {
            if (e.key === "Control") setCtrlPressed(false);
            if (e.key === "Shift") setShiftPressed(false);
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);

    /**
     * 处理左键点击表格行的事件
     * 该操作会展示被点击行的详细信息
     * @param {ProjectSection} record - 左键点击的行数据
     */
    const handleRowClick = (record: Section, index: number) => {
        isDbClickRef.current = false;
        setTimeout(() => {
            if (isDbClickRef.current) return;
            setDetailItem(null);
            if (ctrlPressed) {
                // Ctrl + 单击：多选/取消选中
                if (selecItems.some(item => item.id === record.id)) {
                    // 如果已选中，移除
                    setSelecItems(selecItems.filter(item => item.id !== record.id));
                } else {
                    // 如果未选中，添加
                    setSelecItems([...selecItems, record]);
                }
            } else if (shiftPressed && lastSelectedIndex !== null) {
                // Shift + 单击：区间选择
                const start = Math.min(lastSelectedIndex, index);
                const end = Math.max(lastSelectedIndex, index);
                const rangeItems = projectSection.slice(start, end + 1);

                setSelecItems(prev => {
                    const selectedIds = prev.map(item => item.id);
                    const newItems = rangeItems.filter(item => !selectedIds.includes(item.id)); // 过滤出未选中的
                    return [...prev, ...newItems];
                });
            } else {
                // 单击：单选
                if (selecItems.some(item => item.id === record.id)) {
                    setSelecItems([]);
                } else {
                    setSelecItems([record]);
                }
            }

            setLastSelectedIndex(index); // 更新最后一次点击的索引
        }, 150)
    };

    /**
     * 组件初始化时加载截面数据
     * 在每次截面类型更改时，重新加载项目的截面列表
     */
    useEffect(() => {
        generateData();
        setDetailItem(null);
    }, [])
    /**
     * 查询对应类型的项目库截面数据列表
     * 调用后端接口 `findProjectSectionList` 获取项目下的截面信息并更新状态
     */
    const generateData = () => {
        findProjectSectionsGroup(projectUuid).then(res => {

            setProjectSection(res.data.sections || []);
            setDisplaySection(res.data.sections || []);
            // 截面大类存入对应下拉框变量
            const uniqueCategoryList = res.data.categories.map((category: any) => ({
                label: category.name as string,
                value: category.id as string,
            })) as { label: string; value: string }[];

            setSectionCategoryList(uniqueCategoryList);

            // 默认选中第一个截面大类
            if (uniqueCategoryList.length > 0) {
                setSectionCategory(uniqueCategoryList[0].value); // 默认选中第一个选项
            }

            // 截面标准去重后存入对应下拉框变量
            const uniqueStandards = Array.from(new Set(res.data.sources)).map((source: string) => ({
                label: source,
                value: source,
            }));

            setStandardList(uniqueStandards);

            // 二级截面类型去重后存入属性变量
            const uniqueTypes = Array.from(
                new Map((res.data.types || []).map((type: any) => [type.type, type])).values()
            );
            setSectionTypeList(uniqueTypes)

        }).catch(err => {
            message.error("获取当前类型的数据信息失败");
        });
    }

    /**
     * 列表行右键点击事件处理
     * @param e 鼠标事件
     * @param record 当前右键点击的表单数据
     */
    const onRowRightClick = (e: React.MouseEvent, record: Section) => {
        e.preventDefault();
        // 判断当前点击的对象是否已经在选中的列表中
        const isAlreadySelected = selecItems.some(item => item.id === record.id);

        if (!isAlreadySelected) {
            // 如果不在选中列表中，则清空 selecItems，并只选中当前点击的对象
            setSelecItems([record]);
        }

        setCmLeft(e.clientX);
        setCmTop(e.clientY);
        setDetailItem(null);
        setCmOpen(true);
    }
    /**
     * 截面类型下拉框选择操作
     * @param value 
     */
    const handleSectionTypeChange = (value) => {
        setSectionCategory(value);
    };
    /**
     * 截面标准下拉框选择操作
     * @param value 
     */
    const handleStandardChange = (value) => {
        setStandard(value);
    };

    // 点击左侧分类
    const onClickLeftType = (type) => {
        setSelectedSectionTypeId(type);
        updateStatus(type, []);
    }

    /**
     * 当选择了截面大类，筛选截面类型
     */
    useEffect(() => {
        if (sectionCategory) {
            const filteredTypeList = sectionTypeList.filter(
                (type) => type.category === parseInt(sectionCategory)
            );
            setDisplayTypeList(filteredTypeList);
        } else {
            setDisplayTypeList(sectionTypeList); // 如果没有选择 `sectionCategory`，显示全部
        }
    }, [sectionCategory, sectionTypeList]); // 当 `sectionCategory` 或 `sectionTypeList` 变化时重新计算

    /**
     * 当选择了截面类型或者选择了截面标准，筛选截面列表
     */
    useEffect(() => {
        let filteredSections = projectSection;

        // 筛选标准：`standard`
        if (standard) {
            filteredSections = filteredSections.filter(
                (section) => section.secSource === standard
            );
        }

        // 筛选类型：`selectedSectionTypeId`
        if (selectedSectionTypeId) {
            filteredSections = filteredSections.filter(
                (section) => section.type === parseInt(selectedSectionTypeId) // 假设 `selectedSectionTypeId` 和 `section.type` 是数字
            );
        }

        setDisplaySection(filteredSections); // 更新筛选后的列表
    }, [standard, selectedSectionTypeId, projectSection]); // 当这些依赖变化时重新计算


    /**
     * 删除截面操作
     * 显示确认弹窗，确认后调用后端删除接口
     */
    const onDelete = () => {

        // 获取需要删除的截面 ID 列表
        const idsToDelete = selecItems ? selecItems.map(item => item.id) : [];

        if (idsToDelete.length === 0) {
            message.warning("请选择要删除的截面");
            return;
        }

        // 如果 tasksCount 不为空，显示确认弹窗
        TnModal().deleteModal({
            onOk() {
                TnModal().destoryAll();
                setCmOpen(false);
                handleBatchDelete(idsToDelete);
            },
            onCancel() {
                setCmOpen(false);
                TnModal().destoryAll();
            },
        });
    };


    /**
     * 执行批量删除逻辑
     * @param idsToDelete 截面 ID 列表
     */
    const handleBatchDelete = (idsToDelete: string[]) => {
        deleteProjectSectionBySectionIds(projectUuid, idsToDelete).then((res) => {
            if (res.status === 200) {
                findProjectSectionsGroup(projectUuid).then((res) => {
                    onSave(res.data); // 将最新的截面数据传递给父组件
                }).catch(() => {
                    message.error("获取最新的截面数据失败！");
                });
            }
        })
            .catch((err) => {
                message.error("删除失败，请稍后重试");
            })
            .finally(() => {
                setSelecItems([]);
                setCmOpen(false);
            });
    };

    /**
     * 系统库添加截面操作
     */
    const addUser = () => {
        setDetailItem(null); // 清空详情项
        setSelecItems([]);
        setCmOpen(false);
        setShowAddModal(true);
    };

    /**
     * 处理库添加用户列表的保存时间
     * 将在库添加列表的新添加或者去除的新项目列表保存到 displayUsers 列表中
     */
    const onSave = (selectedItems: ProjectSection) => {
        const { categories, types, sources, sections } = selectedItems;

        // 更新 projectSection 和 displaySection
        const newSections = sections || [];
        const currentSectionIds = projectSection.map((item) => item.id);
        const addedSections = newSections.filter((section) => !currentSectionIds.includes(section.id));
        const removedSectionIds = currentSectionIds.filter((id) => !newSections.some((section) => section.id === id));

        // 添加新 sections
        const updatedProjectSection = [
            ...projectSection.filter((section) => !removedSectionIds.includes(section.id)),
            ...addedSections,
        ];
        setProjectSection(updatedProjectSection);

        // 更新 sectionTypeList 和 displayTypeList
        const newTypes = types || [];
        const currentTypeIds = sectionTypeList.map((type) => type.type);
        const addedTypes = newTypes.filter((type) => !currentTypeIds.includes(type.type));
        const removedTypeIds = currentTypeIds.filter((id) => !newTypes.some((type) => type.type === id));

        const updatedTypeList = [
            ...sectionTypeList.filter((type) => !removedTypeIds.includes(type.type)),
            ...addedTypes,
        ];

        // 去重处理，确保 type.type 不重复
        const deduplicatedTypeList = Array.from(new Map(updatedTypeList.map((type) => [type.type, type])).values());
        setSectionTypeList(deduplicatedTypeList);


        // 更新 displayTypeList 根据当前选中的分类
        if (sectionCategory) {
            const filteredTypeList = updatedTypeList.filter((type) => type.category === parseInt(sectionCategory));
            setDisplayTypeList(filteredTypeList);
        } else {
            setDisplayTypeList(updatedTypeList);
        }

        // 更新 standardList
        const newSources = sources || [];
        const currentStandards = standardList.map((item) => item.value);
        const addedStandards = newSources.filter((source) => !currentStandards.includes(source));
        const removedStandards = currentStandards.filter((source) => !newSources.includes(source));

        const updatedStandardList = [
            ...standardList.filter((item) => !removedStandards.includes(item.value)),
            ...addedStandards.map((source) => ({ label: source, value: source })),
        ];

        // 去重处理，确保 item.value 不重复
        const deduplicatedStandardList = Array.from(
            new Map(updatedStandardList.map((item) => [item.value, item])).values()
        );
        setStandardList(deduplicatedStandardList);


        // 如果当前选中的标准失效，选中第一个标准
        if (standard && !updatedStandardList.some((item) => item.value === standard)) {
            setStandard(updatedStandardList[0]?.value || null);
        }

        // 关闭弹窗
        setShowAddModal(false);
        setDetailItem(null);
        setSelecItems([]);
    };

    // 双击打开详情
    const onDbClick = (row) => {
        isDbClickRef.current = true
        navigate(`/projects/${projectUuid}/section-details/${row.id}`);
    }



    return (
        <div className="section-container" >

            <SideHeader>
                <div className='header'>
                    <span>截面</span>
                    <AddSvg className='add-icon' onClick={addUser} />
                    <NewSvg className='add-icon' onClick={() => { }} />
                </div>
            </SideHeader>

            <div className='select-section-area'>
                {/* 截面大类下拉框 */}
                <Dropdown
                    options={sectionCategoryList || []}
                    value={sectionCategory}
                    onChange={handleSectionTypeChange}
                    wrapClassName="section-select-type"
                />

                {/* 第二个下拉框 */}
                <Dropdown
                    options={standardList || []}
                    value={standard}
                    onChange={handleStandardChange}
                    wrapClassName="section-select-standard"
                />
            </div>
            <LeftSideList leftItems={displayTypeList} uniqueKey="type" activeLeftItemKey={selectedSectionTypeId}
                onClickLeftItem={(e, type) => { onClickLeftType(type.type) }}
                leftItemContainer={({ leftItem }) => {
                    return (
                        <>
                            {!!leftItem.sectionIconUrl && <Image width={48} height={48} preview={false} src={leftItem.sectionIconUrl} />}
                        </>
                    );
                }} activeAddSvg={<Add32Svg className='active' />}
                wrapClassName={'section-left-side'}
            >
                <div className="section-table-area" >
                    <Table
                        rowKey="id" // 数据唯一标识
                        pagination={false} // 禁用分页
                        dataSource={displaySection || []} // 数据源
                        bordered={false} // 无边框
                        className='tn-common-table' // 自定义表格样式
                        onRow={(row, index) => {
                            return {
                                onMouseEnter: () => setHoveredItem(row), // 设置悬浮的行
                                onMouseLeave: () => setHoveredItem(null),  // 清除悬浮状态
                                onClick: (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleRowClick(row, index);
                                },
                                onDoubleClick: (e) => {
                                    // 双击事件，打开截面列表
                                    e.stopPropagation();
                                    e.preventDefault();
                                    isDbClickRef.current = false;
                                    setSelecItems([row]);
                                    setDetailItem(row);
                                    onDbClick(row);
                                },
                                onContextMenu: (e) => {
                                    e.stopPropagation(); // 阻止冒泡
                                    e.preventDefault(); // 阻止默认行为
                                    onRowRightClick(e, row as Section); // 右键点击事件
                                }
                            }
                        }}
                        rowClassName={row => classNames({
                            "common-table-row": true,
                            "common-table-row-active": row.id === detailItem?.id || selecItems.some(item => item.id === row.id),
                        })}
                        sticky // 固定表头
                        showHeader={false} // 隐藏表头
                    >
                        <Table.Column dataIndex="id" title="序号" width={`${80 / 340 * 100}%`} ellipsis
                            render={(value, record, index) => (
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <div style={{ textAlign: 'right', marginLeft: '4px' }}>
                                        {(index + 1).toString().padStart(3, '0')} {/* 序号至少为三位数 */}{/* 序号从 1 开始 */}
                                    </div>
                                </div>
                            )} />
                        <Table.Column dataIndex="name" title="型号" key="name" width={`${180 / 340 * 100}%`} ellipsis />
                    </Table>
                </div>
            </LeftSideList>

            <ContextMenu
                visible={cmOpen} // 是否显示
                top={cmTop} // 菜单纵坐标
                left={cmLeft} // 菜单横坐标
                wrapperClassname='section-list-right-menu' // 自定义右键菜单样式
                onCancel={() => {
                    setCmOpen(false); // 关闭右键菜单
                }}
            >
                <MenuList>
                    <MenuItem onClick={() => { }}>
                        查看详情
                    </MenuItem>
                    <MenuItem onClick={onDelete} special>
                        删除
                    </MenuItem>
                </MenuList>
            </ContextMenu>
            {
                showAddModal && <SectionModal
                    showAddModal={showAddModal}
                    projectSelectedItems={projectSection}
                    onCancel={() => {
                        setShowAddModal(false);
                        setCmOpen(false);
                        setDetailItem(null);
                    }}
                    onSave={onSave}
                />
            }
        </div>

    )
}

